import { GetItemsProps, ResponseDTO, getDate, toISOString } from "medere-ui-framework";
import { axiosInstance } from "../App";
import { PersonalData, ProfileDataFormDTO } from "../dto/profiledata/ProfileDataFormDTO";
import { ComboDataDTO } from "../dto/ComboDataDTO";
import imageCompression from "browser-image-compression";
import { AxiosResponse } from "axios";
import { HomeViewDataDTO } from "../dto/HomeViewDataDTO";

const compressBlobImage = async (blob) => {
  const options = {
    maxSizeMB: 1, // set a max file size in megabytes after compression.
    maxWidthOrHeight: 1920,// set a max dimension (either width or height) for the output image
    useWebWorker: true,// use a web worker for the compression task, offloading the main thread.
  };
  const compressedFile = await imageCompression(blob, options);
  return compressedFile;
};

export function getCities({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get('/api/secured/profile/profiledataform/getCities', {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??''
    }
  }).then((response) => {
    return response.data;
  }).catch((error) => {
    console.error(error);
    throw error;
  });
}

export function loadDocumentTypes({filterValue,offSet,pageSize}:GetItemsProps) {
  return axiosInstance.get(`/api/secured/profile/profiledataform/loadDocumentTypes`, {
    params: {
      offSet,
      pageSize,
      inputText:filterValue??''
    }
  })
  .then((response) => response.data)
  .catch((error) => {
    console.error("Error en loadDocumentTypes:", error.response);
  });
}

export function loadHomeViewDataForUser(): Promise<HomeViewDataDTO> {
  return axiosInstance.get<HomeViewDataDTO>('/api/secured/profile/profiledataform/loadHomeViewDataForUser')
    .then((response) => response.data)
    .catch((error) => {
      console.error(error);
      throw error;
    });
}

/** Establecimientos que el usuario puede elegir como predeterminado. */
export function getSelectableBuildings(): Promise<ComboDataDTO[]> {
  return axiosInstance.get<ComboDataDTO[]>('/api/secured/profile/profiledataform/getSelectableBuildings')
    .then((response) => response.data ?? []);
}

/** Establecimiento a precargar: el de Mi perfil o, si no hay, el del puesto de atención abierto; null si no hay ninguno (204). */
export function getPreferredBuilding(): Promise<ComboDataDTO | null> {
  return axiosInstance.get<ComboDataDTO>('/api/secured/profile/profiledataform/getPreferredBuilding')
    .then((response) => response.data || null);
}

export function loadProfileDataFormForUser(): Promise<ProfileDataFormDTO> {
  return axiosInstance.get<ProfileDataFormDTO>('/api/secured/profile/profiledataform/loadProfileDataFormForUser')
    .then((response) => response.data)
    .catch((error) => {
      console.error(error);
      throw error;
    });
}

export function saveProfileDataFormForUser (profileDataForm:ProfileDataFormDTO){
  if (!profileDataForm.personalData.city?.id || profileDataForm.personalData.city.id <= 0) {
    console.warn('ID de ciudad inválido:', profileDataForm.personalData.city);
  }
  return axiosInstance.post('/api/secured/profile/profiledataform/saveProfileDataFormForUser',{...profileDataForm, personalData:{...profileDataForm.personalData, birthdate: toISOString(getDate(profileDataForm.personalData.birthdate))}, invoiceData: {...profileDataForm.invoiceData, companystartdate: toISOString(getDate(profileDataForm.invoiceData.companystartdate))}}).then(res => res);
}

export function loadPersonalPhoto(): Promise<string> {
  return axiosInstance.post('/api/secured/profile/profiledataform/getPersonalPhoto', null, { responseType: 'blob' })
    .then(async (response) => {
      const compressedImage = await compressBlobImage(response.data);
      const imageURL = URL.createObjectURL(compressedImage);
      return imageURL;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
}

export function loadSignature(): Promise<string> {
  return axiosInstance.post('/api/secured/profile/profiledataform/getSignature', null, { responseType: 'blob' })
    .then(async (response) => {
      const compressedImage = await compressBlobImage(response.data);
      const imageURL = URL.createObjectURL(compressedImage);
      return imageURL;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
}

export function uploadPersonalPhoto(file: File): Promise<void> {
  const formData = new FormData();
  formData.append('personalphoto', file);

  return axiosInstance.post('/api/secured/profile/profiledataform/uploadPersonalPhoto', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  .then(() => {})
  .catch((error) => {
    console.error(error);
    throw error;
  });
}

export function uploadSignature(file: File): Promise<void> {
  const formData = new FormData();
  formData.append('signature', file);

  return axiosInstance.post('/api/secured/profile/profiledataform/uploadSignature', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  .then(() => {})
  .catch((error) => {
    console.error(error);
    throw error;
  });
}

export function getCurrentAfipStep(): Promise<number> {
  return axiosInstance.get("/api/secured/profile/profiledataform/getCurrentAfipStep", {
    params: { }
  }).then((response) => response.data);
}

export function generateAfipPrivateKey(afipAlias: string, vatID: string, afipproductionmode: boolean, iibbperceptionagent: boolean): Promise<boolean> {
  return axiosInstance.get(`/api/secured/profile/profiledataform/generateAfipPrivateKey`, {
    params: {
      afipAlias,
      vatID,
      afipproductionmode,
      iibbperceptionagent
    }
  })
  .then((response) => response.data as boolean)
  .catch((error) => {
    console.error("Error en generateAfipPrivateKey:", error.response);
    return false;
  });
}

export function generateCSRCertificate(): Promise<string> {
  return axiosInstance.get(`/api/secured/profile/profiledataform/generateCSRCertificate`, {})
  .then((response) => {
    return response.data as string
  } )
  .catch((error) => {
    console.error("Error en generateAfipPrivateKey:", error.response);
    return null;
  });
}

export function saveAfipCertificate(dueDate: Date, certificate: string): Promise<boolean> {
  return axiosInstance.get(`/api/secured/profile/profiledataform/saveAfipCertificate`, {
    params: {
      dueDateUTC:dueDate?.getTime(),
      certificate: certificate.replace(/\n/g, "\r\n")
    }
  })
  .then((response) => response.data as boolean)
  .catch((error) => {
    console.error("Error en generateAfipPrivateKey:", error.response);
    return false;
  });
}

export function testAfipConnection(afipProductionMode: boolean): Promise<ResponseDTO> {
  return axiosInstance.post("/api/secured/profile/profiledataform/testAfipConnection", null, {
    params: { afipProductionMode }
  }).then((response) => response.data);
}